import React from "react";
import logo from "../assets/namastelogo.png";
import { useNavigate } from "react-router-dom";

// const Footer = () => {
//   return (
//     <div className="mx-auto max-w-screen-xl px-4 pb-6 pt-16 sm:px-6 lg:px-8 lg:pt-24">
//       <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
//         <div>
//           <div className="flex justify-center text-indigo-600 sm:justify-start">
//             <img className="h-16" src={logo} alt="logo" />
//           </div>

//           <p className="mt-6 max-w-md font-bold text-center leading-relaxed text-indigo-600 sm:max-w-xs sm:text-left">
//             Namaste Transportation LLC
//           </p>
//           <p className="mt-6 max-w-md text-center leading-relaxed text-gray-600 sm:max-w-xs sm:text-left">
//             Reach Your Medical Destination With Us
//           </p>
//         </div>

//         <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-4 lg:col-span-2">
//           <div className="text-center sm:text-left">
//             <p className="text-lg font-medium text-indigo-600">Learn More</p>

//             <ul className="mt-8 space-y-4 text-sm">
//               <li>
//                 <a
//                   className="text-gray-700 transition hover:text-gray-700/75"
//                   href="/"
//                 >
//                   How To Book a Ride
//                 </a>
//               </li>

//               <li>
//                 <a
//                   className="text-gray-700 transition hover:text-gray-700/75"
//                   href="/"
//                 >
//                   {" "}
//                   About Namaste Transportation
//                 </a>
//               </li>

//               <li>
//                 <a
//                   className="text-gray-700 transition hover:text-gray-700/75"
//                   href="/"
//                 >
//                   {" "}
//                   About The Owner
//                 </a>
//               </li>
//             </ul>
//           </div>

//           <div className="text-center sm:text-left">
//             <p className="text-lg font-medium text-indigo-600">Contact Us</p>

//             <ul className="mt-8 space-y-4 text-sm">
//               <li className="flex items-center justify-center gap-1.5 ltr:sm:justify-start rtl:sm:justify-end ">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   className="h-5 w-5 shrink-0 text-gray-900"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
//                   />
//                 </svg>

//                 <span className="flex-1 text-gray-700">
//                   namaste.nmt@gmail.com
//                 </span>
//               </li>

//               <li>
//                 <a
//                   className="flex items-center justify-center gap-1.5 ltr:sm:justify-start rtl:sm:justify-end"
//                   href="/"
//                 >
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     className="h-5 w-5 shrink-0 text-gray-900"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
//                     />
//                   </svg>

//                   <span className="flex-1 text-gray-700">
//                     {" "}
//                     Cell: 7202858473
//                   </span>
//                 </a>
//               </li>
//               <li>
//                 <a
//                   className="flex items-center justify-center gap-1.5 ltr:sm:justify-start rtl:sm:justify-end"
//                   href="/"
//                 >
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     className="h-5 w-5 shrink-0 text-gray-900"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
//                     />
//                   </svg>

//                   <span className="flex-1 text-gray-700">
//                     Office: 3033405809
//                   </span>
//                 </a>
//               </li>

//               <li className="flex items-start justify-center gap-1.5 ltr:sm:justify-start rtl:sm:justify-end">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   className="h-5 w-5 shrink-0 text-gray-900"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
//                   />
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
//                   />
//                 </svg>

//                 <address className="-mt-0.5 flex-1 not-italic text-gray-700">
//                   14201 East 4th Avenue. Suite 4-260 Aurora, Colorado 80011
//                 </address>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </div>

//       <div className="mt-12 border-t border-gray-100 pt-6">
//         <div className="text-center sm:flex sm:justify-between sm:text-left">
//           <p className="text-sm text-gray-500">
//             <span className="block sm:inline">All rights reserved.</span>

//             <p className="inline-block text-indigo-600 transition hover:text-indigo-600/75">
//               Terms & Conditions
//             </p>

//             <span>&middot;</span>

//             <p className="inline-block text-indigo-600 transition hover:text-indigo-600/75">
//               Privacy Policy
//             </p>
//           </p>

//           <p className="mt-4 text-sm text-gray-500 sm:order-first sm:mt-0">
//             &copy; 2024 Namaste Transportation
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Footer;
const Footer = () => {
  const navigate = useNavigate();
  const handleContactClick = () => {
    navigate("/contact");
    window.scrollTo(0, 0);
  };

  const handleBookClick = () => {
    navigate("/Book");
    window.scrollTo(0, 0);
  };

  const handleAboutClick = () => {
    navigate("/about");
    window.scrollTo(0, 0);
  };

  return (
    <footer className="bg-white gradient">
      <svg
        className="wave-top"
        viewBox="0 0 1439 147"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xlinkHref="http://www.w3.org/1999/xlink"
      >
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g transform="translate(-1.000000, -14.000000)" fill-rule="nonzero">
            <g className="wave" fill="#f8fafc">
              <path d="M1440,84 C1383.555,64.3 1342.555,51.3 1317,45 C1259.5,30.824 1206.707,25.526 1169,22 C1129.711,18.326 1044.426,18.475 980,22 C954.25,23.409 922.25,26.742 884,32 C845.122,37.787 818.455,42.121 804,45 C776.833,50.41 728.136,61.77 713,65 C660.023,76.309 621.544,87.729 584,94 C517.525,105.104 484.525,106.438 429,108 C379.49,106.484 342.823,104.484 319,102 C278.571,97.783 231.737,88.736 205,84 C154.629,75.076 86.296,57.743 0,32 L0,0 L1440,0 L1440,84 Z"></path>
            </g>
            <g transform="translate(1.000000, 15.000000)" fill="#FFFFFF">
              <g transform="translate(719.500000, 68.500000) rotate(-180.000000) translate(-719.500000, -68.500000) ">
                <path
                  d="M0,0 C90.7283404,0.927527913 147.912752,27.187927 291.910178,59.9119003 C387.908462,81.7278826 543.605069,89.334785 759,82.7326078 C469.336065,156.254352 216.336065,153.6679 0,74.9732496"
                  opacity="0.100000001"
                ></path>
                <path
                  d="M100,104.708498 C277.413333,72.2345949 426.147877,52.5246657 546.203633,45.5787101 C666.259389,38.6327546 810.524845,41.7979068 979,55.0741668 C931.069965,56.122511 810.303266,74.8455141 616.699903,111.243176 C423.096539,147.640838 250.863238,145.462612 100,104.708498 Z"
                  opacity="0.100000001"
                ></path>
                <path
                  d="M1046,51.6521276 C1130.83045,29.328812 1279.08318,17.607883 1439,40.1656806 L1439,120 C1271.17211,77.9435312 1140.17211,55.1609071 1046,51.6521276 Z"
                  opacity="0.200000003"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </svg>
      <section className="container mx-auto text-center py-6 mb-12">
        <h1 className="w-full my-2 text-5xl font-bold leading-tight text-center text-gray-500">
          Namaste Transportation
        </h1>
        <div className="w-full mb-4">
          <div className="h-1 mx-auto bg-white w-1/6 opacity-25 my-0 py-0 rounded-t"></div>
        </div>

        <h3 className="my-4 text-3xl leading-tight uppercase text-gray-400">
          Reach your Medical Destination with Us!
        </h3>

        <p className="text-black font-bold">
          14201 E 4th Ave. Ste. 4-200 Aurora CO 80011
        </p>
        <p className="text-black">
          <span className="font-bold">Office.</span> (303) 955-4856
        </p>
        <p className="text-black">
          <span className="font-bold">Fax. </span>(303) 955-4870
        </p>
        <div className="text-black mt-4">
          <h3 className="font-bold">Office Hours</h3>
          <p>Monday-Friday</p>
          <p>9:00am - 5:00pm</p>
        </div>
        <div className="w-full mb-4">
          <div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t"></div>
        </div>
      </section>
      <hr className="border-b border-gray-100 opacity-25 my-0 py-0" />
      <div className="container mx-auto  px-8">
        <div className="w-full flex flex-col md:flex-row py-6">
          <div className="flex-1 mb-6 text-black">
            <img className="w-[120px]" src={logo} alt="logo" />
          </div>

          <div className="flex-1">
            <p className="uppercase text-gray-500 md:mb-6">Info</p>
            <ul className="list-reset mb-6">
              <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                <button
                  onClick={handleBookClick}
                  className="no-underline hover:underline text-gray-800 hover:text-[#A4C6AF]"
                >
                  Book
                </button>
              </li>
              <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                <button
                  onClick={handleContactClick}
                  className="no-underline hover:underline text-gray-800 hover:text-[#A4C6AF]"
                >
                  Contact Us
                </button>
              </li>
            </ul>
          </div>
          <div className="flex-1">
            <p className="uppercase text-gray-500 md:mb-6">Social</p>
            <ul className="list-reset mb-6">
              <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                <a
                  href="https://m.facebook.com/61559692601526/"
                  className="no-underline hover:underline text-gray-800 hover:text-[#A4C6AF]"
                >
                  Facebook
                </a>
              </li>
              {/* <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                <a
                  href="#"
                  className="no-underline hover:underline text-gray-800 hover:text-[#A4C6AF]"
                >
                  Instagram
                </a>
              </li> */}
            </ul>
          </div>
          <div className="flex-1">
            <p className="uppercase text-gray-500 md:mb-6">Company</p>
            <ul className="list-reset mb-6">
              <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                <button
                  onClick={handleAboutClick}
                  className="no-underline hover:underline text-gray-800 hover:text-[#A4C6AF]"
                >
                  About Us
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <p className="mt-4 text-sm text-gray-500 sm:order-first sm:mt-0 flex items-center justify-center">
        &copy; 2026 Namaste Transportation
      </p>
      <hr className="border-b border-gray-100 opacity-25 my-0 py-6" />
    </footer>
  );
};

export default Footer;
